import { customElement } from 'lit/decorators';
import { css, html, LitElement, TemplateResult } from 'lit';

declare global {
    interface HTMLElementTagNameMap {
        'ata-medium-heading': AtaMediumHeading;
    }
}

@customElement('ata-medium-heading')
export default class AtaMediumHeading extends LitElement {
    static styles = css`
        :host {
            font-size: 1.25em;
            line-height: 1.25em;
            margin: 0;
        }
    `;

    render(): TemplateResult {
        return html`<slot></slot>`;
    }
}
